var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectListSorted',{attrs:{"facet":_vm.$options.config.facet,"order":"popularity","operator":"AND"},scopedSlots:_vm._u([{key:"icon",fn:function(ref){
var value = ref.value;
return [_c('SvgIcon',{attrs:{"src":_vm.getEquipmentIcon(value)}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }